module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/lake/Room_lake_01.png";